import React, { useState } from 'react';
import { AppointmentButton } from '../components/AppointmentButton';

interface MenuProps {
  onSectionChange: (section: string) => void;
}

export function Menu({ onSectionChange }: MenuProps) {
  const [downloadStatus, setDownloadStatus] = useState<string>('');

  const handleReview = () => {
    window.open('https://g.page/r/CY7tAH_mJCoMEAE/review', '_blank');
  };

  const handleDownloadContact = async () => {
    try {
      setDownloadStatus('Descargando contacto...');
      
      // Create VCard content with proper escaping for special characters
      const vcard = `BEGIN:VCARD
VERSION:3.0
N:Estética y Quiromasaje;Sandra;;;
FN:Sandra Estética y Quiromasaje
ORG:Sandra Estética y Quiromasaje
TITLE:Esteticista y Quiromasajista
TEL;TYPE=WORK,VOICE:+34654261502
ADR;TYPE=WORK:;;Carrer Sant Jacint\\, 32 - 1ª;Paterna;Valencia;46980;España
EMAIL:sanpahe79@gmail.com
URL:https://sandraestetica.app
PHOTO;VALUE=URL;TYPE=JPEG:https://assets.brandbay.io/brands/1740757220342x324895480323506200/assets/uFfXQVIso_Sandra_sq_rosa.jpeg
NOTE:Gabinete de estética y quiromasaje para mujeres en Paterna
END:VCARD`;
      
      // Create blob with proper MIME type
      const blob = new Blob([vcard], { type: 'text/vcard;charset=utf-8' });
      const url = window.URL.createObjectURL(blob);
      
      // Create and configure download link
      const link = document.createElement('a');
      link.style.display = 'none';
      link.href = url;
      link.setAttribute('download', 'Sandra.vcf');
      link.setAttribute('target', '_blank');
      
      // Add to document and trigger click
      document.body.appendChild(link);
      link.click();
      
      // Cleanup after small delay to ensure download starts
      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        setDownloadStatus('¡Contacto descargado!');
        
        // Reset status after 3 seconds
        setTimeout(() => {
          setDownloadStatus('');
        }, 3000);
      }, 100);
    } catch (error) {
      console.error('Error al descargar el contacto:', error);
      setDownloadStatus('Error al descargar el contacto');
      
      // Reset error status after 3 seconds
      setTimeout(() => {
        setDownloadStatus('');
      }, 3000);
    }
  };

  return (
    <div className="mt-auto space-y-4">      
      <div className="grid grid-cols-1 gap-2">
        <button 
          onClick={() => onSectionChange('covid')} 
          className="bg-white h-[40px] rounded-lg shadow-md hover:bg-primary group transition-all flex items-center justify-center"
        >
          <span className="text-lg text-gray-600 group-hover:text-white transition-colors">Protocolo Covid-19</span>
        </button>

        <button 
          onClick={() => onSectionChange('services')} 
          className="bg-white h-[40px] rounded-lg shadow-md hover:bg-primary group transition-all flex items-center justify-center"
        >
          <span className="text-lg text-gray-600 group-hover:text-white transition-colors">Servicios</span>
        </button>

        <button 
          onClick={() => onSectionChange('experience')} 
          className="bg-white h-[40px] rounded-lg shadow-md hover:bg-primary group transition-all flex items-center justify-center"
        >
          <span className="text-lg text-gray-600 group-hover:text-white transition-colors">Experiencia del mes</span>
        </button>

        <button 
          onClick={() => onSectionChange('location')} 
          className="bg-white h-[40px] rounded-lg shadow-md hover:bg-primary group transition-all flex items-center justify-center"
        >
          <span className="text-lg text-gray-600 group-hover:text-white transition-colors">Localización</span>
        </button>

        <button 
          onClick={() => onSectionChange('recommend')} 
          className="bg-white h-[40px] rounded-lg shadow-md hover:bg-primary group transition-all flex items-center justify-center"
        >
          <span className="text-lg text-gray-600 group-hover:text-white transition-colors">Recomiéndame</span>
        </button>

        <button 
          onClick={() => onSectionChange('share')} 
          className="bg-white h-[40px] rounded-lg shadow-md hover:bg-primary group transition-all flex items-center justify-center"
        >
          <span className="text-lg text-gray-600 group-hover:text-white transition-colors">Compartir aplicación</span>
        </button>

        <button 
          onClick={handleDownloadContact}
          className="bg-white h-[40px] rounded-lg shadow-md hover:bg-primary group transition-all flex items-center justify-center relative"
        >
          <span className="text-lg text-gray-600 group-hover:text-white transition-colors">
            {downloadStatus || 'Guardar contacto'}
          </span>
        </button>

        <button 
          onClick={handleReview}
          className="bg-white h-[40px] rounded-lg shadow-md hover:bg-primary group transition-all flex items-center justify-center"
        >
          <span className="text-lg text-gray-600 group-hover:text-white transition-colors">¡Dame 5 estrellas!</span>
        </button>
      </div>

      <div className="mt-4 mb-5">
        <AppointmentButton 
          className="bg-primary text-white hover:bg-primary/90 h-[40px] flex items-center justify-center rounded-lg"
        />
      </div>
    </div>
  );
}